import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ServiceWorkerGuard } from '#components/tools/service-worker-guard.tsx';
export const Route = createFileRoute('/_authentication')({
  component: PathlessLayoutComponent,
})

function PathlessLayoutComponent() {
  return (
    <div className="d-flex vh-100">      
      <div className="col-12"><ServiceWorkerGuard><Outlet/></ServiceWorkerGuard></div>

    </div>
  )
}